import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {VetineoApiResponse} from "../models/vetineo-api-response.model";
import {map} from "rxjs/operators";
import {ApiService} from "./api.service";
import {CommonUtils} from "../utils/common";
import {DataGridServiceInterface} from "./data-grid-service.interface";
import {UserCarePlanItemDgSearchResults} from "../models/datagrid-search-results/user-care-plan-item.dg-search-results.model";
import {UserCarePlanItem} from "../models/user-care-plan-item.model";

/**
 * Serwis warstwy danych obsługujący pojedyncze elementy (usługi/produkty)
 * wchodzące w skład zdefiniowanych Planów Opieki (Abonamentów) przypisanych do pacjentów.
 * Ogranicza się do operacji odczytu (Read-Only) na potrzeby zasilania
 * widoków tabelarycznych i raportów (DataGrid).
 */
@Injectable({
  providedIn: 'root'
})
export class UserCarePlanItemService implements DataGridServiceInterface<Observable<UserCarePlanItemDgSearchResults>> {

  constructor(private apiService: ApiService, public commonUtils: CommonUtils) {
  }

  /**
   * Pobiera paginowaną listę pojedynczych elementów przypisanych planów opieki.
   *
   * @param limit Maksymalna liczba rekordów na stronę.
   * @param offset Przesunięcie wyników względem początku zbioru.
   * @param sortOrder Kierunek sortowania (np. 'ASC', 'DESC').
   * @param orderBy Nazwa kolumny, według której aplikowane jest sortowanie.
   * @param showDeletedObjects Flaga decydująca o widoczności zarchiwizowanych/anulowanych elementów.
   * @returns Observable emitujący ustandaryzowany obiekt wyników dla komponentu DataGrid.
   */
  getResults(limit: number, offset: number, sortOrder: string, orderBy: string, showDeletedObjects: boolean = false): Observable<UserCarePlanItemDgSearchResults> {
    return this.apiService.get<VetineoApiResponse>(`/dashboard/user-care-plan-items/${showDeletedObjects}/${limit}/${offset}/${sortOrder}/${orderBy}`, {}).pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        return new UserCarePlanItemDgSearchResults(vetineoApiResponse.response.total, this.commonUtils.bestTypedArrayCopyEver(new UserCarePlanItem(), [], vetineoApiResponse.response.results), vetineoApiResponse.response.csrfToken);

      } else {
        return undefined;
      }
    }));
  }

  /**
   * Wyszukuje i filtruje elementy planów opieki na podstawie zaawansowanych kryteriów
   * (np. status wykorzystania, przypisany pacjent, nazwa konkretnej usługi w pakiecie).
   *
   * @param limit Rozmiar strony.
   * @param offset Przesunięcie.
   * @param searchFieldsData Mapa zawierająca zdefiniowane filtry wyszukiwania.
   * @param sortOrder Kierunek sortowania.
   * @param orderBy Nazwa kolumny sortującej.
   * @param showDeletedObjects Flaga widoczności usuniętych rekordów.
   * @returns Observable emitujący przefiltrowaną listę elementów dla DataGrid.
   */
  searchForResults(limit: number, offset: number, searchFieldsData: Map<string, string>, sortOrder: string, orderBy: string, showDeletedObjects: boolean = false): Observable<UserCarePlanItemDgSearchResults> {
    const data = {
      limit: limit,
      offset: offset,
      searchFieldsData: this.commonUtils.mapToSearchFieldList(searchFieldsData),
      sortOrder: sortOrder,
      orderBy: orderBy,
      showDeletedObjects: showDeletedObjects
    }
    return this.apiService.post<VetineoApiResponse>(`/dashboard/user-care-plan-items/search`, data).pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        console.log(vetineoApiResponse.response.results);
        return new UserCarePlanItemDgSearchResults(vetineoApiResponse.response.total, this.commonUtils.bestTypedArrayCopyEver(new UserCarePlanItem(), [], vetineoApiResponse.response.results), vetineoApiResponse.response.csrfToken);
      } else {
        return undefined;
      }
    }));
  }

}
